import React from 'react'
import styled from 'styled-components'
import PaymentIcon from 'react-payment-icons'
import { suggestiveColor } from '@/style-guide/colors'
import { Typography } from 'antd'
import { FaCcVisa, FaCcMastercard } from 'react-icons/fa';

const Line = styled.div`
  border-color: ${suggestiveColor};
  margin: 5px 0;
  display: flex;
  line-height: 20px;
  width: 100%;
`

export const Card = ({ card, hideName }) => {
  return (
    <Line>
      <div style={{ display: 'flex', gap: '20px' }}>
        {card?.card?.brand === 'visa' && <FaCcVisa className="cc-card-icon" />}
        {card?.card?.brand === 'mastercard' && <FaCcMastercard className="cc-card-icon" />}
        <Typography.Text>
          {!hideName && (
            <>
              <Typography.Text>
                {(card?.billing_details && card.billing_details?.name) ||
                  (card?.payment && card.payment?.name)}
              </Typography.Text>
              <br />
            </>
          )}
          <span style={{ textTransform: 'capitalize' }}>
            {card?.card?.brand}
          </span>{' '}
          card ending in {card?.card?.last4}
          <br />
          Expiry {card?.card?.exp_month}/{card.card?.exp_year}
        </Typography.Text>
      </div>
    </Line>
  )
}
